import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ============================================================
// 🌍 i18n แบบ Lazy — โหลดเฉพาะไฟล์ภาษาที่ใช้จริง
// ============================================================
// เดิม: import ทั้ง 8 ภาษา (~430KB) ฝังใน main.js ทุกครั้ง
// ใหม่: dynamic import ตามภาษาปัจจุบัน → webpack แยกเป็น chunk ต่อภาษา
//       main.js เบาลง ~370KB ผู้ใช้โหลดแค่ภาษาเดียว (~60KB)
//
// หมายเหตุ: การสลับภาษาใน Navbar ใช้ window.location.reload() อยู่แล้ว
//          → หลัง reload จะ boot ด้วยภาษาใหม่และดึง chunk ของภาษานั้นเอง

const SUPPORTED = ['en', 'th', 'lo', 'vi', 'zh', 'km', 'my', 'id'];

const getInitialLanguage = () => {
  try {
    const saved = JSON.parse(localStorage.getItem('Language'));
    if (SUPPORTED.includes(saved)) return saved;
  } catch (e) { /* localStorage เสีย → ใช้ค่า default */ }
  return 'lo';
};

i18n.use(initReactI18next).init({
  resources: {}, // ★ ว่าง — โหลดทีหลังผ่าน loadLocale()
  lng: getInitialLanguage(),
  fallbackLng: 'lo',
  interpolation: {
    escapeValue: false,
  },
});

// ★ โหลดไฟล์ภาษาแบบ dynamic (cache ใน i18next หลังโหลดครั้งแรก)
export const loadLocale = async (lng) => {
  const target = SUPPORTED.includes(lng) ? lng : 'lo';
  if (i18n.hasResourceBundle(target, 'translation')) return;
  try {
    const mod = await import(
      /* webpackChunkName: "locale-[request]" */
      `./locales/${target}.json`
    );
    i18n.addResourceBundle(target, 'translation', mod.default, true, true);
  } catch (e) {
    console.warn('โหลดไฟล์ภาษาไม่สำเร็จ:', target, e);
  }
};

// ตอนบูทแอป: โหลดภาษาที่เลือก + ภาษา fallback (lo) ถ้าไม่ใช่ภาษาเดียวกัน
// index.js จะรอ promise นี้ก่อน render — กันหน้าจอโชว์ key ดิบๆ ตอนเปิดเว็บ
const bootLanguage = i18n.language;
export const i18nReady = (async () => {
  if (bootLanguage !== 'lo') await loadLocale('lo'); // สำรองไว้ให้ fallbackLng
  await loadLocale(bootLanguage);
})();

export default i18n;
